import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClock, faWrench } from "@fortawesome/free-solid-svg-icons";

export const InicioPage = () => {
  const navigate = useNavigate();

  return (
    <div className="inicio-container">
      <div className="botones-inicio">
        <button
          className="btn-grande"
          onClick={() => navigate("/app/jornada")}
        >
          <FontAwesomeIcon icon={faClock} className="btn-icon-grande" />
          <span className="btn-texto">Iniciar Jornada Laboral</span>
        </button>

        <button
          className="btn-grande"
          onClick={() => navigate("/app/intervencion")}
        >
          <FontAwesomeIcon icon={faWrench} className="btn-icon-grande" />
          <span className="btn-texto">Iniciar Intervención</span>
        </button>
      </div>
    </div>
  );
};
